import React from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {Dimmer, Loader} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {STATUS_SUBMITTED_TO_FEMA} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {getTimestampNowISO} from 'common/utils';
import {
  STATUS_CLOSED,
  STATUS_INELIGIBLE,
  STATUS_NOT_SELECTED,
  STATUS_SUBAWARD_RESCINDED,
} from 'app-ui-componentlibrary/dist/common/constants';

class InitiateCloseoutReportModal extends React.Component {
  state = {
    open: false,
    cancelling: false,
    message: '',
    selectedGrantId: '',
  };

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps) {
    this.refreshData();
  }

  refreshData() {
    const {open, token, entity, entityType} = this.props;
    const {selectedGrantId} = this.state;
    let grantId = entity.grantId;

    if (!_.isEqual(selectedGrantId, grantId)) {
      this.setState({
        selectedGrantId: grantId,
        message: '',
        open: this.props.open,
        entityType: entityType,
      });
    } else if (!_.isEqual(open, this.state.open)) {
      this.setState({open: this.props.open});
    }
  }

  handleCancel = () => {
    const cancel = () => this.props.onCancel();
    this.setState({open: false});
    cancel();
  };

  handleConfirm = () => {
    const {token, entity} = this.props;
    const {entityType, selectedGrantId, message} = this.state;
    let currentDate = getTimestampNowISO();
    const data = {
      entityId: selectedGrantId,
      statusTimestamp: currentDate,
      status: 'closeoutInitiated',
    };
    const callbackMethod = (allowedWithoutSubgrant, allowedWithSubgrant) => {
      if (_.isEmpty(message)) {
        if (allowedWithoutSubgrant) {
          this.setState({
            open: false,
            cancelling: false,
            message:
              'You can not initiate closeout with Payments or Amendments in "Submitted to FEMA" status or if a Closeout report exists.',
          });
        } else if (allowedWithSubgrant) {
          this.setState({
            open: false,
            cancelling: false,
            message:
              'You can not initiate closeout with Payments or Amendments in "Submitted to FEMA status", if a Closeout report exists, or open subgrants.',
          });
        } else {
          this.createEntity(entityType);
          REST.dynamicData
            .patchEntity(token, data)
            .then(REST.handler.handleResponse)
            .then(() => {
              this.setState({open: false, cancelling: false, message: ''});
              this.props.onCancel();
            })
            .catch((error) => {
              this.setState({
                cancelling: false,
                message:
                  'An error happened while trying to patch the status for this grant.',
              });
              console.error(
                'An error happened while trying to patch the status for this grant: '
              );
            });
        }
      } else {
        this.setState({open: false, cancelling: true, message: ''});
        window.location.reload(false);
      }
    };

    this.setState({cancelling: true, message: ''});
    this.checkPaymentsAmendments(selectedGrantId, callbackMethod);
  };

  checkPaymentsAmendments(grantId, callback) {
    const {token, onError} = this.props;
    let amendments = [];
    let payments = [];
    let closeoutReports = [];
    let subGrants = [];

    const closeoutStatuses = [
      STATUS_CLOSED,
      STATUS_INELIGIBLE,
      STATUS_NOT_SELECTED,
      STATUS_SUBAWARD_RESCINDED,
    ];

    REST.dynamicData
      .getAllByGrantIdAndEntityType(token, grantId, 'amendment')
      .then(REST.handler.handleResponse)
      .then((data) => {
        _.map(data, (amendment) => {
          amendments.push(amendment.status);
        });
      })
      .then(() => {
        REST.dynamicData
          .getAllByGrantIdAndEntityType(token, grantId, 'payment')
          .then(REST.handler.handleResponse)
          .then((data) => {
            _.map(data, (payment) => {
              payments.push(payment.status);
            });
          })
          .then(() => {
            REST.dynamicData
              .getAllByGrantIdAndEntityType(token, grantId, 'closeoutReport')
              .then(REST.handler.handleResponse)
              .then((data) => {
                _.map(data, (closeoutReport) => {
                  closeoutReports.push(closeoutReport.status);
                });
              })
              .then(() => {
                REST.dynamicData
                  .getAllByGrantIdAndEntityType(token, grantId, 'subGrant')
                  .then(REST.handler.handleResponse)
                  .then((data) => {
                    _.map(data, (subGrant) => {
                      subGrants.push(subGrant.status);
                    });
                    let activePaymentsAmendments =
                      _.includes(amendments, STATUS_SUBMITTED_TO_FEMA) ||
                      _.includes(payments, STATUS_SUBMITTED_TO_FEMA) ||
                      !_.isEmpty(closeoutReports);

                    let activePaymentsAmendmentsWithoutSubgrants =
                      activePaymentsAmendments && _.isEmpty(subGrants);

                    const activePaymentsAmendmentsWithSubgrants =
                      !_.isEmpty(subGrants) &&
                      (activePaymentsAmendments ||
                        !_.every(subGrants, (status) =>
                          _.includes(closeoutStatuses, status)
                        ));

                    callback(
                      activePaymentsAmendmentsWithoutSubgrants,
                      activePaymentsAmendmentsWithSubgrants
                    );
                  });
              });
          });
      })
      .catch((error) => {
        this.setState({
          cancelling: false,
          message:
            'An error happened while trying to create the closeoutReport entity for this grant.',
        });
        console.error(
          'An error happened while trying to create the closeoutReport entity for this grant: '
        );
      });
  }

  createEntity(entityType) {
    const {token, onError} = this.props;
    const {selectedGrantId} = this.state;

    let createEntityRequest = 'createEntity';

    REST.dynamicData[createEntityRequest](token, selectedGrantId, entityType)
      .then(REST.handler.handleResponse)
      .then((entityData) => {
        if (entityData.errors != null) {
          onError(entityData);
        } else {
          this.setState({
            entityType: entityData.entityType,
            entityId: entityData.entityId,
          });
        }
      })
      .catch((error) => {
        this.setState({
          cancelling: false,
          message:
            'An error happened while trying to create the closeoutReport entity for this grant.',
        });
        console.error(
          'An error happened while trying to create the closeoutReport entity for this grant: '
        );
      });
  }

  render() {
    const {entity} = this.props;
    const {open, cancelling, message, entityType, entityId} = this.state;

    if (entityId && entityType) {
      return <Redirect to={`/${entityType}/${entityId}/edit`} push />;
    }
    return (
      open && (
        <FemaGoModal
          type="alert"
          size="medium"
          title="Initiate Closeout"
          className="modal-title"
          open={open}
          confirmAction={this.handleConfirm}
          buttonText="Confirm"
          cancelButtonText="Cancel"
          buttonType={'primary'}
          cancelAction={this.handleCancel}
        >
          <hr />
          {!_.isEmpty(message) && (
            <Alert header="" htmlContent={message} alertType="error" />
          )}
          {cancelling && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
          <p>
            <strong>{`Grant ID:  ${entity.grantId}`}</strong>
          </p>
          <p>
            {this.props.customCloseoutMessage
              ? this.props.customCloseoutMessage
              : 'Before initiating closeout, you should complete all post-award activities and be ready to enter the closeout phase. In the closeout phase, any payments issued through FEMA GO will be issued after the FEMA review of your closeout report which may take some time, and the amendment feature will be disabled. If you have immediate cash needs, please submit a payment request prior to initiating closeout. If you need prior approval from FEMA on any outstanding issues, please submit an amendment request prior to initiating closeout. You will be able to return to the post-award phase if necessary to re-enable the FEMA GO payment and amendment features, but you will lose any work you have performed on your closeout report.'}
          </p>

          <br />
        </FemaGoModal>
      )
    );
  }
}

export default withRouter(InitiateCloseoutReportModal);
